/* eslint-disable no-console */
/* eslint-disable no-undef */
import environment from "src/utils/environment";
const updateEvent = new Event("new-version-available");
const ONE_DAY = 24 * 60 * 60 * 1000;
let isCurrent = true;

const checkVersion = async () => {
  try {
    const response = await fetch("app-version.json", { cache: "no-store" });
    const { version } = await response.json();
    if (version > APP_VERSION) {
      console.log(`New version available: ${version} > ${APP_VERSION}`);
      document.dispatchEvent(updateEvent);
      isCurrent = false;
    }
  } catch (err) {
    console.error("Error trying to fetch current app version");
  }
};

const create = () => {
  if (!environment.isBrowser) return;
  checkVersion();
  setInterval(checkVersion, ONE_DAY);
};

const getIsCurrent = () => isCurrent;

const appUpdater = { create, getIsCurrent };
export default appUpdater;
